import { type ForbiddenApiErrorDialogProps, useForbiddenApiErrorDialog } from './state';

/**
 * グローバルエラーダイアログを表示する
 */
export function openForbiddenApiErrorDialog(props: ForbiddenApiErrorDialogProps) {
  useForbiddenApiErrorDialog.getState().open(props);
}

/**
 * グローバルエラーダイアログを閉じる
 */
export function closeForbiddenApiErrorDialog() {
  useForbiddenApiErrorDialog.getState().close();
}